/**
 * Typed provider enterprise billing API facade over the generated contract client.
 */

import * as schemas from '@cnapse/shared/schemas.js';
import { providerEnterpriseApi } from '../api/generated/providerEnterprise.api.js';

class ProviderEnterpriseService {
  async extendEnterprisePilot(
    data: schemas.ExtendEnterprisePilotRequest,
  ): Promise<schemas.EnterpriseSubscriptionData> {
    return providerEnterpriseApi.extendPilot(data) as Promise<schemas.EnterpriseSubscriptionData>;
  }

  async recordEnterprisePayment(
    data: schemas.RecordEnterprisePaymentRequest,
  ): Promise<schemas.EnterpriseSubscriptionData> {
    return providerEnterpriseApi.recordPayment(data) as Promise<schemas.EnterpriseSubscriptionData>;
  }

  async expireEnterprisePilot(
    data: schemas.EnterpriseTenantActionRequest,
  ): Promise<schemas.EnterpriseSubscriptionData> {
    return providerEnterpriseApi.expirePilot(data) as Promise<schemas.EnterpriseSubscriptionData>;
  }

  async listEnterprisePackages(
    params?: schemas.ListEnterprisePackagesRequest,
  ): Promise<schemas.EnterprisePackageData[]> {
    return providerEnterpriseApi.listPackages(params ?? {}) as Promise<schemas.EnterprisePackageData[]>;
  }

  async createEnterprisePackage(
    data: schemas.CreateEnterprisePackageRequest,
  ): Promise<schemas.EnterprisePackageData> {
    return providerEnterpriseApi.createPackage(data) as Promise<schemas.EnterprisePackageData>;
  }

  async updateEnterprisePackage(
    packageId: string,
    data: schemas.UpdateEnterprisePackageRequest,
  ): Promise<schemas.EnterprisePackageData> {
    return providerEnterpriseApi.updatePackage(packageId, data) as Promise<schemas.EnterprisePackageData>;
  }

  async archiveEnterprisePackage(packageId: string): Promise<void> {
    await providerEnterpriseApi.archivePackage(packageId);
  }

  async assignEnterprisePackage(
    data: schemas.AssignEnterprisePackageRequest,
  ): Promise<schemas.EnterpriseSubscriptionData> {
    return providerEnterpriseApi.assignPackage(data) as Promise<schemas.EnterpriseSubscriptionData>;
  }
}

export const providerEnterpriseService = new ProviderEnterpriseService();
